import { MutationTree } from 'vuex';
import { ILocaleState } from '@/store/interfaces';

export const mutations: MutationTree<ILocaleState> = {
  SET_LOCALE(state, value) {
    state.locale = value;
    localStorage.setItem('locale', value);
  },
};
